import React from 'react'
import { SvgProps } from './SvgProps'
import { svgTransform } from './svgTramsform'

export const FullCircleSvg = ({ size }: SvgProps) => {
  return (
    <svg
      width="32"
      height="24"
      viewBox="0 0 32 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transform: svgTransform(size),
      }}
    >
      <path
        d="M32 9C32 10.6569 30.6569 12 29 12C27.3431 12 26 10.6569 26 9C26 7.34315 27.3431 6 29 6C30.6569 6 32 7.34315 32 9Z"
        fill="#EB2D23"
      />
      <path
        d="M26 14C26 12.8954 26.8954 12 28 12H30C31.1046 12 32 12.8954 32 14V19H26V14Z"
        fill="#EB2D23"
      />
      <path
        d="M0 3C0 1.89543 0.895431 1 2 1H22C23.1046 1 24 1.89543 24 3V21C24 22.1046 23.1046 23 22 23H2C0.89543 23 0 22.1046 0 21V3Z"
        fill="#EB2D23"
      />
      <path
        d="M15 9C15 10.6569 13.6569 12 12 12C10.3431 12 9 10.6569 9 9C9 7.34315 10.3431 6 12 6C13.6569 6 15 7.34315 15 9Z"
        fill="white"
      />
      <path
        d="M8 9C8 10.6569 6.65685 12 5 12C3.34315 12 2 10.6569 2 9C2 7.34315 3.34315 6 5 6C6.65685 6 8 7.34315 8 9Z"
        fill="white"
      />
      <path
        d="M22 9C22 10.6569 20.6569 12 19 12C17.3431 12 16 10.6569 16 9C16 7.34315 17.3431 6 19 6C20.6569 6 22 7.34315 22 9Z"
        fill="white"
      />
      <path
        d="M9 14C9 12.8954 9.89543 12 11 12H13C14.1046 12 15 12.8954 15 14V19H9V14Z"
        fill="white"
      />
      <path
        d="M2 14C2 12.8954 2.89543 12 4 12H6C7.10457 12 8 12.8954 8 14V19H2V14Z"
        fill="white"
      />
      <path
        d="M16 14C16 12.8954 16.8954 12 18 12H20C21.1046 12 22 12.8954 22 14V19H16V14Z"
        fill="white"
      />
    </svg>
  )
}
